import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const HIDDEN_PATHS = ["/donate", "/checkout/return", "/auth", "/reset-password"];

export function StickyDonateBar() {
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(sessionStorage.getItem("sticky_donate_dismissed") === "1");
  }, []);

  if (dismissed || HIDDEN_PATHS.some((p) => pathname.startsWith(p)) || pathname.startsWith("/admin")) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t bg-background/95 px-3 py-2 shadow-lg backdrop-blur md:hidden">
      <div className="flex items-center gap-2">
        <div className="flex-1 text-sm">
          <div className="font-semibold">Help fund the next project</div>
          <div className="text-xs text-muted-foreground">100% goes to families in Sri Lanka</div>
        </div>
        <Button asChild size="sm" className="rounded-full">
          <Link to="/donate">
            <Heart className="mr-1 h-4 w-4" /> Donate
          </Link>
        </Button>
        <button
          aria-label="Dismiss"
          onClick={() => {
            sessionStorage.setItem("sticky_donate_dismissed", "1");
            setDismissed(true);
          }}
          className="p-1 text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
